import { Link } from "react-router-dom";
import "./Header.css";

const Header = ({ showHome }) => {
  return (
    <header
      style={{
        paddingBottom: "1rem",
        borderBottom: "1px solid black",
      }}
    >
      <div className="outer-container">
        <div className="header-container">
          <Link style={{ textDecoration: "none" }} to="/">
            <h1 style={{ marginBottom: 0 }}>1 Good Thing - At a Time</h1>
          </Link>
          <div style={{ display: "flex" }}>
            {showHome && (
              <Link className="header-link" to="/">
                Home
              </Link>
            )}
            {!showHome && (
              <a className="header-link" href="https://snackdriven.dev">
                More Snacks
              </a>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
